/**
 * Layui UMD 入口
 */

// 导入核心模块
import { lay, use, version } from './core/lay.js';
import { loader } from './core/loader.js';
import { laytpl } from './core/laytpl.js';
import { i18n } from './core/i18n.js';
import { router } from './core/router.js';
import { default as jquery, default as $ } from 'jquery';
import { component, componentBuilder } from './core/component.js';

// 导入组件模块
import { laypage } from './components/laypage.js';
import { laydate } from './components/laydate.js';
import { layer } from './components/layer.js';
import { dropdown } from './components/dropdown.js';
import { slider } from './components/slider.js';
import { colorpicker } from './components/colorpicker.js';
import { nav } from './components/nav.js';
import { breadcrumb } from './components/breadcrumb.js';
import { progress } from './components/progress.js';
import { collapse } from './components/collapse.js';
import { element } from './components/element.js';
import { upload } from './components/upload.js';
import { form } from './components/form.js';
import { formSelects } from './components/formSelects.js';
import { tagsinput } from './components/tagsinput.js';
import { autocomplete } from './components/autocomplete.js';
import { table } from './components/table.js';
import { treeTable } from './components/treeTable.js';
import { tabs } from './components/tabs.js';
import { tree } from './components/tree.js';
import { transfer } from './components/transfer.js';
import { carousel } from './components/carousel.js';
import { rate } from './components/rate.js';
import { flow } from './components/flow.js';
import { util } from './components/util.js';
import { code } from './components/code.js';
import { country } from './components/country.js';
import { datetime } from './components/datetime.js';
import { cookie } from './components/cookie.js';
import { ClipboardJS } from './components/clipboard.js';
import { Sortable, sortable } from './components/sortable.js';
import { dragsort } from './components/dragsort.js';
import { qrcode } from './components/qrcode.js';
import { jqzoom } from './components/jqzoom.js';
import { selectY } from './components/selectY.js';
import { fileManage } from './components/fileManage.js';
import { pictureManage } from './components/pictureManage.js';
import { videoManage } from './components/videoManage.js';
import { musicManage } from './components/musicManage.js';
import { contentEditor } from './components/contentEditor.js';
import { objectManage } from './components/objectManage.js';
import { jcropFace } from './components/jcropFace.js';
import { tinymce } from './components/tinymce.js';
import { echarts } from './components/echarts.js';
import { websocket, socket } from './components/websocket.js';

const layui = {
  lay,
  use,
  version,
  loader,
  laytpl,
  i18n,
  router,
  $,
  jquery,
  component,
  componentBuilder,
  layer,
  laydate,
  laypage,
  dropdown,
  slider,
  colorpicker,
  nav,
  breadcrumb,
  progress,
  collapse,
  element,
  upload,
  form,
  formSelects,
  tagsinput,
  autocomplete,
  table,
  treeTable,
  tabs,
  tree,
  transfer,
  carousel,
  rate,
  flow,
  util,
  code,
  country,
  datetime,
  cookie,
  ClipboardJS,
  Sortable,
  sortable,
  dragsort,
  qrcode,
  jqzoom,
  selectY,
  fileManage,
  pictureManage,
  videoManage,
  musicManage,
  contentEditor,
  objectManage,
  jcropFace,
  tinymce,
  echarts,
  websocket,
  socket,
};

export default layui;
